import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { isPlatformAdmin } from "../../platformClient.js";

export function PlatformGuard({ children }: { children: ReactNode }) {
  if (!isPlatformAdmin()) {
    return <Navigate to="/platform/signin" replace />;
  }
  return <>{children}</>;
}
